<template>
  <div
    class="modal fade"
    id="addToNodModal"
    data-backdrop="static"
    data-keyboard="false"
    tabindex="-1"
    role="dialog"
    aria-labelledby="addToNodModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content " v-if="show">
        <div class="modal-header shadow-sm border-outline-dark-bottom">
          <h6
            class="modal-title font-weight-bold text-light"
            id="addToNodModalLabel"
          >
            <p class="mb-1">Add Case to NOD</p>
            <div class="line-height-1" v-if="currentCase">
              <small class="text-muted">Case Number</small>
              <p class="mb-0 font-weight-medium text-muted">
                {{ currentCase.caseNumber }}
              </p>
            </div>
          </h6>
          <button
            type="button"
            class="close text-light"
            aria-label="Close"
            @click="closeModal()"
            data-placement="top"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
            title="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body ">
          <div class="row mx-0">
            <div class="col">
              <div class="form-group mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small text-light">
                    NOD Serial No.<sup class="text-danger">*</sup>
                  </label>
                  <div v-if="currentCase">
                    <button
                      v-show="!isCreatingNOD"
                      class="btn btn-sm btn-link"
                      @click="isCreatingNOD = true"
                      data-placement="top"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Click to create new NOD"
                    >
                      <span class="small">Create new NOD</span>
                    </button>
                    <button
                      v-show="isCreatingNOD"
                      class="btn btn-sm btn-link"
                      @click="isCreatingNOD = false"
                      data-placement="top"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Click to existing NOD"
                    >
                      <span class="small">Select existing NOD</span>
                    </button>
                  </div>
                </div>
                <template v-if="!isCreatingNOD && currentCase">
                  <div class="dropdown rounded w-100">
                    <button
                      class="btn btn-sm border btn-block dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3 bg-dark-input text-light border-outline-dark"
                      style="font-size: 0.875rem; color: #495057"
                      type="button"
                      id="dropdownNodButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-placement="top"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Select NOD case"
                    >
                      <span v-if="currentNod">
                        {{
                          currentNod &&
                          nodCases.find((nod) => nod.id == currentNod.id)
                            .serialNo
                        }}
                      </span>
                      <span v-else class="text-muted">-- Select nod case</span>
                    </button>
                    <div
                      class="dropdown-menu py-0 w-100 shadow-sm text-light p-0"
                      aria-labelledby="dropdownNodButton"
                      style="
                        height: 200px;
                        overflow: hidden;
                        font-size: 0.875rem;
                      "
                    >
                      <input
                        class="form-control form-control-sm  border-outline-dark-bottom text-light"
                        placeholder="Search"
                        v-model="searchModel"
                        data-placement="top"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        title="Search nod case"
                      />
                      <div style="height: calc(100% - 43px); overflow-y: auto">
                        <button
                          v-for="nod in computedNodCases"
                          :key="`select-nod-${nod.id}`"
                          class="border-bottom dropdown-item px-3 py-2  border-outline-dark text-light"
                          :class="{
                            'bg-subtle': currentNod && currentNod.id == nod.id,
                          }"
                          style="color: #495057"
                          @click="selectNod(nod.id)"
                        >
                          {{ nod.serialNo }}
                          <font-awesome-icon
                            :icon="['fas', 'check']"
                            class="text-primary ml-2 small"
                            v-if="currentNod && currentNod.id == nod.id"
                          />
                        </button>
                        <div
                          class="py-2 small text-center text-muted font-italic  px-3 py-2 fs-8"
                        >
                          <span v-if="computedNodCases.length > 0">
                            End of list
                          </span>
                          <span v-else>No nod case found</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div
            class="px-3 pt-3"
            v-if="!isCreatingNOD && currentNod && currentNod.id"
          >
            <div class="mb-3">
              <label class="small text-light">NOD Date</label>
              <p
                class="mb-0 form-control form-control-default form-control-sm bg-dark-input text-light"
              >
                {{ currentNod.timestamp }}
              </p>
            </div>
            <div class="mb-3">
              <label class="small text-light">Completion</label>
              <p
                class="mb-0 form-control form-control-default form-control-sm bg-dark-input text-light"
              >
                {{
                  (currentNod.nod_site_visit &&
                    currentNod.nod_site_visit.completion) ||
                  "--"
                }}
                days
              </p>
            </div>
            <div class="mb-3">
              <label class="small text-light">District</label>
              <p
                class="mb-0 form-control form-control-default form-control-sm bg-dark-input text-light"
              >
                {{ districtName(currentNod.district) }}
              </p>
            </div>
            <div class="mb-3">
              <label class="small text-light">Road</label>
              <p
                class="mb-0 form-control form-control-default form-control-sm bg-dark-input text-light"
              >
                {{ roadName(currentNod.road) }}
              </p>
            </div>

            <div class="mb-3">
              <label class="small text-light">Description</label>
              <p
                class="mb-0 form-control form-control-default form-control-sm bg-dark-input text-light"
                style="height: auto"
              >
                {{
                  (currentNod.nod_site_visit &&
                    currentNod.nod_site_visit.description) ||
                  "--"
                }}
              </p>
            </div>
            <div class="mb-3">
              <label class="small text-light">Recommendation</label>
              <p
                class="mb-0 form-control form-control-default form-control-sm bg-dark-input text-light"
                style="height: auto"
              >
                {{
                  (currentNod.nod_site_visit &&
                    currentNod.nod_site_visit.recommendation) ||
                  "--"
                }}
              </p>
            </div>
            <div class="mb-3">
              <label class="small text-light">Photos</label>
              <div
                class="media-grid no-pseudo"
                v-if="currentNod.photos && currentNod.photos.length > 0"
              >
                <div :key="file.id" v-for="file in currentNod.photos">
                  <div class="img-container">
                    <img
                      :src="helper.formatMediaUrl(file)"
                      @click="currentMedia = helper.formatMediaUrl(file)"
                    />
                  </div>
                </div>
              </div>
              <div
                v-else
                class="mb-0 form-control form-control-default form-control-sm bg-dark-input text-light font-italic"
              >
                No photos
              </div>
            </div>
          </div>
          <template v-if="isCreatingNOD || !currentCase">
            <div class="row m-0">
              <div class="col">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control form-control-default form-control-sm bg-dark-input text-light"
                    id="SerialNo"
                    placeholder="Enter NOD serial no."
                    v-model="models.serialNo"
                    data-placement="top"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    title="Insert NOD serial no."
                  />
                </div>
              </div>
            </div>
            <div class="row m-0">
              <div class="col">
                <div class="form-group">
                  <label class="small text-light" for="TypeOfDefect">
                    Type of Defect
                  </label>
                  <input
                    type="text"
                    step="any"
                    min="0"
                    class="form-control form-control-default form-control-sm bg-dark-input text-light"
                    id="TypeOfDefect"
                    placeholder="Enter type of defect"
                    v-model="models.typeOfDefect"
                    data-placement="top"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    title="Insert type of defect"
                  />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label class="small text-light" for="timestamp">
                    Date<sup class="text-danger">*</sup>
                  </label>
                  <p
                    class="form-control form-control-default form-control-sm d-flex justify-content-between align-items-center clickable bg-dark-input text-light"
                    @click="showDateSelector = true"
                    data-placement="top"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    title="Select date and time"
                  >
                    <span>{{ formatDate(models.timestamp) }}</span>
                    <font-awesome-icon :icon="['far', 'calendar-alt']" />
                  </p>
                </div>
              </div>
            </div>
            <div class="row mx-0">
              <div class="col">
                <div class="form-group">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <label class="small text-light">Group Type</label>
                  </div>
                  <div class="dropdown rounded w-100">
                    <button
                      class="btn btn-sm border btn-block dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3 bg-dark-input text-light border-outline-dark"
                      style="font-size: 0.875rem; color: #495057"
                      type="button"
                      id="dropdownGroupTypeButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-placement="top"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Select group type"
                    >
                      <span v-if="models.groupType">
                        {{ models.groupType }}
                      </span>
                      <span v-else class="text-muted">
                        -- Select Group Type
                      </span>
                    </button>
                    <div
                      class="dropdown-menu py-0 w-100 shadow-sm text-light p-0"
                      aria-labelledby="dropdownGroupTypeButton"
                      style="
                        height: 200px;
                        overflow: hidden;
                        font-size: 0.875rem;
                      "
                    >
                      <div style="height: calc(100% - 43px); overflow-y: auto">
                        <button
                          v-for="groupType in listOfGroupType"
                          :key="groupType"
                          class="border-bottom dropdown-item px-3 py-2  border-outline-dark text-light"
                          :class="{
                            'bg-subtle': models.groupType == groupType,
                          }"
                          style="color: #495057"
                          @click="models.groupType = groupType"
                        >
                          {{ groupType }}
                          <font-awesome-icon
                            :icon="['fas', 'check']"
                            class="text-primary ml-2 small"
                            v-if="models.groupType == groupType"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mx-0">
              <div class="col">
                <div class="form-group">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <label class="small text-light">
                      District<sup class="text-danger">*</sup>
                    </label>
                  </div>
                  <div class="dropdown rounded w-100">
                    <button
                      class="btn btn-sm border btn-block dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3 bg-dark-input text-light border-outline-dark"
                      style="font-size: 0.875rem; color: #495057"
                      type="button"
                      id="dropdownDistrictButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-placement="top"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Select district"
                    >
                      <span
                        v-if="
                          districts.find(
                            (district) => models.district == district.id
                          )
                        "
                      >
                        {{
                          districts.find(
                            (district) => district.id == models.district
                          ).name
                        }}
                      </span>
                      <span v-else class="text-muted">
                        -- Select district
                      </span>
                    </button>
                    <div
                      class="dropdown-menu py-0 w-100 shadow-sm text-light p-0"
                      aria-labelledby="dropdownDistrictButton"
                      style="
                        height: 200px;
                        overflow: hidden;
                        font-size: 0.875rem;
                      "
                    >
                      <input
                        class="form-control form-control-sm  border-outline-dark-bottom text-light"
                        placeholder="Search"
                        v-model="districtSearchModel"
                        data-placement="top"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        title="Search district"
                      />
                      <div style="height: calc(100% - 43px); overflow-y: auto">
                        <button
                          v-for="district in computedDistricts"
                          :key="`select-district-${district.id}`"
                          class="border-bottom dropdown-item px-3 py-2  border-outline-dark text-light"
                          :class="{
                            'bg-subtle': models.district == district.id,
                          }"
                          style="color: #495057"
                          @click="models.district = district.id"
                        >
                          {{ district.name }}
                          <font-awesome-icon
                            :icon="['fas', 'check']"
                            class="text-primary ml-2 small"
                            v-if="models.district == district.id"
                          />
                        </button>
                        <div
                          class="py-2 small text-center text-muted font-italic  px-3 py-2 fs-8"
                        >
                          <span v-if="computedDistricts.length > 0">
                            End of list
                          </span>
                          <span v-else>No district found</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mx-0">
              <div class="col">
                <div class="form-group">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <label class="small text-light">
                      Road<sup class="text-danger">*</sup>
                    </label>
                  </div>
                  <div class="dropdown rounded w-100">
                    <button
                      class="btn btn-sm border btn-block dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3 bg-dark-input text-light border-outline-dark"
                      style="font-size: 0.875rem; color: #495057"
                      type="button"
                      id="dropdownRoadButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      :disabled="!models.district"
                      data-placement="top"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Select road"
                    >
                      <span v-if="roads.find((road) => road.id == models.road)">
                        {{ roads.find((road) => road.id == models.road).name }}
                      </span>
                      <span v-else class="text-muted">-- Select road</span>
                    </button>
                    <div
                      class="dropdown-menu py-0 w-100 shadow-sm text-light p-0"
                      aria-labelledby="dropdownRoadButton"
                      style="
                        height: 200px;
                        overflow: hidden;
                        font-size: 0.875rem;
                      "
                    >
                      <input
                        class="form-control form-control-sm  border-outline-dark-bottom text-light"
                        placeholder="Search"
                        v-model="roadSearchModel"
                        data-placement="top"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        title="Search road"
                      />
                      <div style="height: calc(100% - 43px); overflow-y: auto">
                        <button
                          v-for="road in computedRoads"
                          :key="road.id"
                          class="border-bottom dropdown-item d-flex justify-content-between align-items-center px-3 py-2  border-outline-dark text-light"
                          :class="{
                            'bg-subtle': models.road == road.id,
                          }"
                          style="color: #495057"
                          @click="models.road = road.id"
                        >
                          {{ road.name }}
                          <font-awesome-icon
                            :icon="['fas', 'check']"
                            class="text-primary ml-2 small"
                            v-if="models.road == road.id"
                          />
                        </button>
                        <div
                          class="py-2 small text-center text-muted font-italic  px-3 py-2 fs-8"
                        >
                          <span v-if="computedRoads.length > 0">
                            End of list
                          </span>
                          <span v-else>No road found</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row m-0">
              <div class="col">
                <div class="form-group">
                  <label class="small text-light" for="TypeOfDefect">
                    Coordinate
                  </label>
                  <div class="row">
                    <div class="col px-2">
                      <input
                        type="text"
                        step="any"
                        min="0"
                        class="form-control form-control-default form-control-sm bg-dark-input text-light"
                        id="lat"
                        placeholder="Enter latitude"
                        v-model="models.lat"
                        data-placement="top"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        title="Insert latitude"
                      />
                    </div>
                    <div class="col px-2">
                      <input
                        type="text"
                        step="any"
                        min="0"
                        class="form-control form-control-default form-control-sm bg-dark-input text-light"
                        id="lng"
                        placeholder="Enter longitude"
                        v-model="models.lng"
                        data-placement="top"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        title="Insert longitude"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer shadow border-outline-dark-top">
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="closeModal()"
            data-placement="top"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
            title="Click to cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="saveChanges()"
            :disabled="isProcessing"
            data-placement="top"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
            title="Click to save"
          >
            <div
              class="spinner-border spinner-border-sm text-light"
              v-if="isProcessing"
            ></div>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
    <spinner v-if="isProcessing" />

    <date-selector
      v-if="showDateSelector"
      :date="show !== 'add' ? models.timestamp : new Date()"
      @close="dateSelected"
    />
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import Helper from "@/helper";
import Spinner from "@/components/Spinner";
import MediaPreview from "@/components/MediaPreview";
import DateSelector from "@/components/DateSelector";
import Swal from "sweetalert2";

export default {
  name: "add-to-nod-modal",
  props: ["show", "currentCase", "nodCases", "districts"],
  components: { Spinner, MediaPreview, DateSelector },
  data() {
    return {
      listOfGroupType: ["KJP", "Emergency", "Electrical"],
      currentMedia: null,
      helper: Helper,
      isProcessing: false,
      isCreatingNOD: false,
      roads: [],
      searchModel: null,
      districtSearchModel: null,
      roadSearchModel: null,
      models: {
        id: null,
        cases: [],
        district: null,
        road: null,
        groupType: null,
        typeOfDefect: null,
        timestamp: null,
        lat: null,
        lng: null,
        serialNo: null,
      },
      emptyModels: {
        id: null,
        cases: [],
        district: null,
        road: null,
        groupType: null,
        typeOfDefect: null,
        timestamp: null,
        lat: null,
        lng: null,
        serialNo: null,
      },
      map: null,
      currentNod: null,
      showDateSelector: false,
    };
  },
  watch: {
    show: {
      async handler() {
        if (this.show) {
          $("#addToNodModal").modal("show");

          this.models = JSON.parse(JSON.stringify(this.emptyModels));

          if (this.currentNod == null) {
            this.isCreatingNOD = false;
          } else {
            this.isCreatingNOD = true;
          }

          // await this.getDistricts();
        } else {
          this.roads = [];

          if (this.map) {
            this.map.remove();
            this.map = null;
          }
          $("#addToNodModal").modal("hide");
        }
      },
      immediate: true,
    },
    isCreatingNOD: {
      async handler() {
        if (!this.isCreatingNOD) {
          this.models = JSON.parse(JSON.stringify(this.emptyModels));

          this.searchModel = null;

          this.districtSearchModel = null;

          this.roadSearchModel = null;
        } else {
          this.currentNod = null;
        }
      },
      immediate: true,
    },
    currentNod: {
      async handler() {
        this.searchModel = null;
      },
      immediate: true,
      deep: true,
    },
    "models.district": {
      async handler() {
        if (this.models.district) {
          this.models.road = null;

          this.districtSearchModel = null;

          await this.getRoads();
        }
      },
      immediate: true,
      deep: true,
    },
    "models.road": {
      async handler() {
        if (this.models.road) {
          this.roadSearchModel = null;

          const road = this.roads.find((r) => r.id == this.models.road);

          if (road) {
            this.models.lat = road.lat;

            this.models.lng = road.lng;
          }
        } else {
          this.models.lat = null;

          this.models.lng = null;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    districtName() {
      return (id) =>
        this.districts?.find((district) => district.id == id)?.name || "--";
    },
    roadName() {
      return (id) =>
        this.districts
          ?.find((district) => district.id == this.currentNod?.district)
          ?.roads?.find((road) => road.id == id)?.name || "--";
    },
    computedNodCases() {
      let list = JSON.parse(JSON.stringify(this.nodCases));

      if (this.searchModel) {
        list = list.filter((l) =>
          l.serialNo.toLowerCase().includes(this.searchModel.toLowerCase())
        );
      }

      return list;
    },
    computedDistricts() {
      let list = JSON.parse(JSON.stringify(this.districts));

      if (this.districtSearchModel) {
        list = list.filter((l) =>
          l.name.toLowerCase().includes(this.districtSearchModel.toLowerCase())
        );
      }

      return list;
    },
    computedRoads() {
      let list = JSON.parse(JSON.stringify(this.roads));

      if (this.roadSearchModel) {
        list = list.filter((l) =>
          l.name.toLowerCase().includes(this.roadSearchModel.toLowerCase())
        );
      }

      return list;
    },
  },
  methods: {
    dateSelected(e) {
      if (e) {
        this.models.timestamp = e;
      }

      this.showDateSelector = false;
    },
    selectNod(id) {
      this.currentNod = this.nodCases.find((nod) => nod.id == id);
    },
    async getRoads() {
      this.isProcessing = true;

      this.roads =
        this.districts.find((district) => district.id == this.models.district)
          ?.roads || [];

      this.isProcessing = false;
    },
    formatDate(timestamp) {
      return Helper.formatDate(timestamp, true);
    },
    closeModal(response) {
      if (!this.isProcessing) {
        this.$emit("close", response);
      }
    },
    // initMap() {
    //   return new Promise((resolve) => {
    //     mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;

    //     if (!this.map) {
    //       this.map = new mapboxgl.Map({
    //         container: "find-map",
    //         trackResize: true,
    //         style: "mapbox://styles/mapbox/dark-v11",
    //         center: [101.5183, 3.0738], //3.0738° N, 101.5183° E
    //         zoom: 14,
    //         minZoo: 8,
    //         interactive: true,
    //       });

    //       this.map.addControl(new mapboxgl.NavigationControl());

    //       this.map.on("load", () => {
    //         console.log("map loaded");
    //         this.map.resize();
    //         resolve();
    //       });
    //       this.map.on("click", (e) => {
    //         let latlng = e.lngLat.wrap();
    //         console.log(latlng.lat);
    //         const marker1 = new mapboxgl.Marker()
    //           .setLngLat([latlng.lng, latlng.lat])
    //           .addTo(this.map);
    //       });
    //     } else {
    //       this.map.setCenter([101.5183, 3.0738]);
    //       this.map.setZoom(14);
    //     }
    //   });
    // },
    async saveChanges() {
      this.isProcessing = true;

      if (this.isCreatingNOD) {
        // Create NOD, add to models
        const createNod = await API.post("nod-cases", this.models);

        this.currentNod = createNod.data;

        this.$emit("createNod", createNod.data);
      }

      if (this.currentCase) {
        this.models.cases.push(this.currentCase.id);

        // Add case to nod-cases
        API.put(`nod-cases/${this.currentNod.id}`, {
          cases: this.models.cases.concat(
            this.currentNod.cases?.map((c) => c.id) || []
          ),
        })
          .then((retVal) => {
            this.isProcessing = false;

            Swal.fire("Case added to NOD", "", "success").then(() => {
              this.closeModal(retVal.data);
            });
          })
          .catch((err) => {
            this.isProcessing = false;

            console.error(err);
          });
      } else {
        Swal.fire("NOD Created", "", "success").then(() => {
          this.closeModal();
        });
      }
    },
  },
};
</script>